import React from "react";
import TextField, { TextFieldProps } from "@material-ui/core/TextField";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

import { color } from "style/constants";
import globalTheme from "style/theme";

const newTheme = createTheme({
  ...globalTheme,
  overrides: {
    MuiOutlinedInput: {
      root: {
        "& $notchedOutline": {
          borderColor: color.PALEGRAY
        },
        "&:hover $notchedOutline": {
          borderColor: color.BLUE
        },
        "&$focused $notchedOutline": {
          borderColor: color.BLUE
        }
      },
      input: {
        "&::placeholder": {
          color: color.DARKERGRAY,
          opacity: 1
        }
      }
    },
    MuiInputLabel: {
      root: {
        "&$focused": {
          color: color.BLACK
        }
      }
    }
  }
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
} as any);

const OutlinedInput: React.FC<TextFieldProps> = (props: TextFieldProps) => {
  return (
    <ThemeProvider theme={newTheme}>
      <TextField {...props} />
    </ThemeProvider>
  );
};

export default OutlinedInput;
